import { render, staticRenderFns } from "./LandingPdf.vue?vue&type=template&id=4982d22c&scoped=true"
import script from "./LandingPdf.vue?vue&type=script&lang=js"
export * from "./LandingPdf.vue?vue&type=script&lang=js"
import style0 from "./LandingPdf.vue?vue&type=style&index=0&id=4982d22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4982d22c",
  null
  
)

export default component.exports